// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"style_shimmer__C12iX","skeleton-loading":"style_skeleton-loading__iSLPc"};